const route = [
    {
        path: '/activity/2024qzjc/index', //2024上期中检测
        component: function (resolve) {
            require(['VIEWS/activity/2024qzjc/index.vue'], resolve);
        }
    },
]
export default route;
